import { useEffect, useState } from "react";
import { Copy, KeyRound, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export function MyCode({ onChange }) {
  const [code, setCode] = useState("");
  const [other, setOther] = useState("");
  useEffect(() => { api.get("/network/me").then((r) => setCode(r.data.net_code)); }, []);
  const copy = () => navigator.clipboard?.writeText(code).then(() => toast.success("Codice copiato"));
  const connect = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/network/connections", { code: other });
      toast.success(data.status === "accepted" ? "Collegamento accettato" : "Richiesta di collegamento inviata");
      setOther("");
      onChange();
    } catch (e2) { toast.error(errMsg(e2)); }
  };
  return (
    <div className="mb-5 grid gap-3 md:grid-cols-2">
      <div className="flex items-center gap-3 rounded-md border bg-card px-4 py-3">
        <KeyRound className="h-5 w-5 shrink-0 text-primary" />
        <div className="min-w-0 flex-1">
          <p className="text-xs text-muted-foreground">Il tuo codice socio: condividilo con altri amministratori</p>
          <p className="font-mono text-lg font-bold tracking-wider" translate="no" data-testid="netsoci-my-code">{code || "—"}</p>
        </div>
        <Button size="sm" variant="outline" onClick={copy} disabled={!code} data-testid="netsoci-copy-code"><Copy className="mr-1.5 h-4 w-4" />Copia</Button>
      </div>
      <form onSubmit={connect} className="flex items-center gap-2 rounded-md border bg-card px-4 py-3">
        <Input value={other} onChange={(e) => setOther(e.target.value.toUpperCase())} placeholder="Codice socio, es. SOC-AB12CD" className="font-mono" required minLength={6} data-testid="netsoci-code-input" />
        <Button type="submit" data-testid="netsoci-code-connect"><UserPlus className="mr-1.5 h-4 w-4" />Collegati</Button>
      </form>
    </div>
  );
}
